module.exports = __webpack_public_path__ + "img/moins_4.dad2c280.svg";